import { redirect, RouteObject } from 'react-router-dom';

import { getQuestions, getRecommendedProduct } from '../../data/wizard';
import { productRoute } from '../products';
import Wizard from './Wizard';

export const WIZARD_PATH = '/wizard';

export const wizardRoute: RouteObject = {
  path: WIZARD_PATH,
  element: <Wizard />,
  loader: () => getQuestions(),
  action: async ({ request }) => {
    const formData = await request.formData();
    const recommendedProduct = getRecommendedProduct(formData);
    return redirect(productRoute(recommendedProduct, { recommended: true }));
  },
};
